// extracted by mini-css-extract-plugin
export default {"page":"JdU2G","inner":"ug4zu"};